import React from 'react'
import Layout from '~components/shared/layout/layout'

export default ({ children }) => <Layout>{children}</Layout>
